// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { updatePathValidationsDrawer } from 'redux/modules/pathValidationsDrawer'

const removePathValidationFromDrawer = pathId => (dispatch, getState) => {
  const { pathValidationsDrawer } = getState()

  // remove the specified path's messages from the validations object.
  const pathValidations = (
    pathValidationsDrawer.get('pathValidations')
      .delete(pathId)
  )

  // if we've just removed the last item, close the drawer and empty the header message.
  const heading = (
    pathValidations.size
      ? pathValidationsDrawer.get('heading')
      : null
  )
  const isOpen = (
    pathValidations.size
      ? pathValidationsDrawer.get('isOpen')
      : false
  )

  dispatch(updatePathValidationsDrawer({
    heading,
    isOpen,
    pathValidations,
  }))
}

export default removePathValidationFromDrawer
